module.exports = __webpack_public_path__ + "6dcd510968b752465bfab8291afbc2c0.png";